import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import {fromJS} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

const kindOptions = fromJS([
  {id: "water", label: "Water Pallet"},
  {id: "other", label: "Other Pallet"},
]);

class AddPalletForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, added} = this.props;
    let submitLabel = submitting ? "Standby..." : "Add Pallets";
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Enter or scan one or more pallet ids — their SKUs and serial numbers are resolved automatically.</p>
          {added > 0 &&
            <p>{added} {added === 1 ? "pallet was" : "pallets were"} added. The ids left below were not; see why underneath.</p>}
          <FormFieldsTable>
            <Field
              label="Pallet Kind"
              name="kind"
              component={DropDownInputField}
              data={kindOptions}
              valueKey="id"
              titleKey="label"
              showBlank={false}
              serverError={this.props.errors.kind}
              />
            <Field
              label="Pallet Ids"
              name="palletIds"
              component={TextAreaInputField}
              rows={10}
              placeholder="One per line, or separated by spaces or commas"
              serverError={this.props.errors.palletIds}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddPalletToTransferForm"
})(AddPalletForm);

export default ReduxForm;
